import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { UntypedFormArray } from '@angular/forms';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';

import { investmentsOptions } from '@app/forms/subscription/services/ref';

@Component({
    selector: 'esg-investment-list',
    templateUrl: './esg-investment-list.component.html',
    styleUrls: ['./esg-investment-list.component.scss'],
    standalone: false
})
export class EsgInvestmentListComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  investmentsOptions = investmentsOptions;

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }
  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
